import { render, staticRenderFns } from "./UploadedInvoice.vue?vue&type=template&id=58b78fe6&scoped=true"
import script from "./UploadedInvoice.vue?vue&type=script&lang=js"
export * from "./UploadedInvoice.vue?vue&type=script&lang=js"
import style0 from "./UploadedInvoice.vue?vue&type=style&index=0&id=58b78fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b78fe6",
  null
  
)

export default component.exports